import api from '../api'

const baseUrl = '/BizSchool/api/Admin'

const dadbanTeacherProvider = {
  getAllTeachers(params = {}) {
    return api.post(`${baseUrl}/TeacherTable`, {
      params,
    })
  },

  getTeacher(params) {
    return api.get(`${baseUrl}/EditTeacher/${params}`)
  },

  addTeacher(params) {
    return api.post(`${baseUrl}/Teacher`, params)
  },

  updateTeacher(params = {}) {
    return api.put(`${baseUrl}/Teacher`, params)
  },

  deleteTeacher(params) {
    return api.delete(`${baseUrl}/Teacher/${params}`)
  }
}

export default dadbanTeacherProvider